const notifications = require('../lib/notifications');
const formValidation = require('../lib/formValidation');
const formSubmission = require('../lib/formSubmission');
const requestUtil = require('../lib/requestUtil');

window.addEventListener('load', function() {

    const signInForm = document.getElementById('frm-signin');

    const success = function () {
        const targetUri = requestUtil.getQueryParamValue('target');
        window.location.assign(targetUri ? window.location.origin + targetUri : window.location.origin + '/events');
        return null;
    };

    const unauthorized = function () {
        signInForm.reset();
        signInForm.elements[0].focus();
        return 'Die eingegebenen Zugangsdaten sind ungÃ¼ltig.';
    };

    notifications.init(signInForm);
    formValidation.validateFormDataOnFormSubmission(signInForm);
    formSubmission.submitFormDataOnFormSubmission(signInForm, success, unauthorized);

});
